/**
 * 言語設定の定義
 */
export const LANGUAGE_CONFIG = {
  "en-US": {
    code: "en-US" as const,
    shortCode: "en",
    name: "English",
    label: "English (EN)",
    fallback: null,
  },
  "ja-JP": {
    code: "ja-JP" as const,
    shortCode: "ja",
    name: "日本語",
    label: "日本語 (JP）",
    fallback: "en-US" as const,
  },
  "id-ID": {
    code: "id-ID" as const,
    shortCode: "id",
    name: "Indonesian",
    label: "Bahasa Indonesia (ID)",
    fallback: "en-US" as const,
  },
  "vn-VN": {
    code: "vn-VN" as const,
    shortCode: "vn",
    name: "Vietnamese",
    label: "Tiếng Việt (VN)",
    fallback: "en-US" as const,
  },
  "th-TH": {
    code: "th-TH" as const,
    shortCode: "th",
    name: "Thai",
    label: "ไทย (TH)",
    fallback: "en-US" as const,
  },
  "zh-CN": {
    code: "zh-CN" as const,
    shortCode: "zhCN",
    name: "简体中文",
    label: "简体中文 (CN)",
    fallback: "en-US" as const,
  },
} as const;

export type SupportedLanguage = keyof typeof LANGUAGE_CONFIG;

export const isSupportedLanguage = (
  lang: string,
): lang is SupportedLanguage => {
  return Object.keys(LANGUAGE_CONFIG).includes(lang);
};

/**
 * 言語が日本語かどうか
 */
export const isJapaneseLanguage = (lang: string): boolean => {
  return lang === LANGUAGE_CONFIG["ja-JP"].code;
};

/**
 * 英語圏の言語かどうか
 */
export const isEnglishAreaLanguage = (lang: string): boolean => {
  return lang === LANGUAGE_CONFIG["en-US"].code;
};

/**
 * 言語選択オプションの型定義
 */
export type LocaleOption = {
  value: SupportedLanguage;
  label: string;
};

export const LOCALE_OPTIONS: LocaleOption[] = Object.values(
  LANGUAGE_CONFIG,
).map((lang) => ({
  value: lang.code,
  label: lang.label,
}));
